import React from 'react';

import SectionField from './SectionField';
import { Button } from '@material-ui/core';

interface PinFieldWithButtonProps {
  code?: string;
  hasCode: boolean;
  label: string;
  buttonLabel?: string;
  onClick: () => void;
}

const renderButtonOrCode = (props: PinFieldWithButtonProps): string | JSX.Element => {
  const { code, onClick, buttonLabel } = props;
  if (!code) {
    return (
      <Button variant="outlined" color="inherit" onClick={onClick}>
        {buttonLabel}
      </Button>
    );
  }

  return code;
};

const PinFieldWithButton: React.FC<PinFieldWithButtonProps> = (props) => {
  const { hasCode, label } = props;
  return <>{hasCode && <SectionField label={label}>{renderButtonOrCode(props)}</SectionField>}</>;
};

export default PinFieldWithButton;
